import { getFirestore, doc, updateDoc } from "firebase/firestore";

const updateUserData = async (uid, newData) => {
  try {
    const db = getFirestore();
    const userDocRef = doc(db, "registeredUsers", uid);

    await updateDoc(userDocRef, newData);
    return true;
  } catch (error) {
    return false;
  }
};

export default updateUserData;
